export default __webpack_public_path__ + "static/icon-72063929300bd4c72a82d4b42a4c04d3.png";